/**
 * A helper for working with the JSON structure which represent
 * filters in API requests.
 */
export default class Filters {
  constructor(filtersJSON = {}) {
    this.filtersJSON = filtersJSON;
  }

  removeFilter(filterKey, filtersMap = this.filtersJSON) {
    function go(filterKey, filtersMap) {
      const filtered = Object.entries(filtersMap).reduce(
        (acc, [filterName, filterValue]) => {
          if (filterName === filterKey) {
            return acc;
          }

          if (["all", "any", "none"].includes(filterName)) {
            const nestedFiltersArray = filterValue;
            filterValue = nestedFiltersArray.reduce((acc, nestedFiltersMap) => {
              const updatedNestedFiltersMap = go(filterKey, nestedFiltersMap);
              if (updatedNestedFiltersMap) {
                return acc.concat(updatedNestedFiltersMap);
              } else {
                return acc;
              }
            }, []);
          }

          return {
            ...acc,
            [filterName]: filterValue
          };
        },
        {}
      );

      if (Object.keys(filtered).length === 0) {
        return;
      }
      return filtered;
    }

    const filtered = go(filterKey, filtersMap);
    return new Filters(filtered);
  }

  getListOfAppliedFilters(filters = this.filtersJSON) {
    return Object.entries(filters).reduce((acc, [key, value]) => {
      if (!["all", "any", "none"].includes(key)) {
        acc.indexOf(key) < 0 && acc.push(key);
      } else {
        value.forEach(nestedValue => {
          Object.keys(nestedValue).forEach(nestedKey => {
            if (!["all", "any", "none"].includes(nestedKey)) {
              acc.indexOf(key) < 0 && acc.push(nestedKey);
            } else {
              acc = [
                ...acc,
                ...this.getListOfAppliedFilters(nestedValue)
              ].filter((item, index, self) => self.indexOf(item) === index);
            }
          });
        });
      }
      return acc;
    }, []);
  }
}
